import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
// @ts-ignore - css provided via CDN + verbatim <style> emulation in index.html (postcss noop recovery)
import './index.css'
import { Toaster } from 'sonner'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <Toaster position="top-center" richColors closeButton />
  </React.StrictMode>
)
